<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 260px">
      <div class="left-top" @click="onAdd({})">
        <div class="flex-1 font-16-30313a">定额分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :menu-data="classifyList" :permission="permission" :cateType="2" @on-edit="onEditClassify" @on-delete="onDeleteClassify"  @on-add="onAdd"
                   @on-choose="onChooseMenu" :special-item="1" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-f5971d"></span>
            {{currentClassify.name}}
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class="border-none" type="text" placeholder="输入项目关键字/编码" v-model="keywords" clearable @keyup.enter.native="onSearch(1)"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="onSearch(1)">搜索</button>
        </div>
      </div>
      <div class="flex mb-10">
        <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 65px;" @click="onAddQuota">
          <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
          新增
        </div>
        <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 90px;" @click="batchSetEnable(1)">
          <div class="mr-5">
            <i class="el-icon-video-play" style="color: #f5971d; font-size: 14px"></i>
          </div>
          批量启用
        </div>
        <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 90px;" @click="batchSetEnable(-1)">
          <div class="mr-5">
            <i class="el-icon-remove" style="color: #f5971d; font-size: 14px"></i>
          </div>
          批量取消
        </div>
        <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 90px;" @click="setDefaultItem">
          <img src="/static/images/customer/feidanyubao.png" class="icon-14 mr-5" alt="">
          默认特项
        </div>
        <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 90px;" @click="setDefaultCode">
          <div class="mr-5">
            <i class="el-icon-s-order" style="color: #f5971d; font-size: 14px"></i>
          </div>
          默认编码
        </div>
        <div class="btn-24-bd-e2-bg-ff flex align-center" style="min-width: 70px;" @click="onDeleteQuota" v-if="permission.includes('deleteQuota')">
          <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
          删除
        </div>
        <div class="flex-1"></div>
        <div class="btn-24-bd-e2 mr-5 flex align-center" style="min-width: 66px;">
          <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
          <el-upload
            multiple
            name="file"
            :httpRequest="httpRequestImport"
            :action="upImport"
            :show-file-list="false">
            <div style="margin: 10px auto 10px auto">导入</div>
          </el-upload>
        </div>
        <div class="btn-24-bd-e2 flex align-center mr-5" style="min-width: 66px;" @click="materialExport">
          <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
          导出
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading"
                     is-edit="true" :column-data="columnData" @on-switch="onChangeStatus" @on-modify="onModifyQuotaInRow"
                     modify-method="on-modify" @on-change-modify="onChangeModify"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
      <move-vertical :max="560" :min="220" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 280px">
        <div class="flex align-center">
          <div class="flex align-center mr-20 cursor pb-5 relative" :class="{'tabActive': index === smallTabIndex}" v-for="(item, index) in smallTab" :key="index" @click="switchSmallTab(index)">
            <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === smallTabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item}}</div>
          </div>
        </div>
        <div class="hr mb-10"></div>
        <div class="overflow-y flex-1">
          <div class="text-left h-100" v-if="smallTabIndex === 0">
            <el-row :gutter="40">
              <el-col :span="6" class="info-item">
                <div>定额编码：<el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyQuota('code')" v-model="currentRow.code"></el-input></div>
              </el-col>
              <el-col :span="12" class="info-item">
                <div>工作内容：<el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyQuota('name')" v-model="currentRow.name"></el-input></div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>单位：<el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyQuota('unit')" v-model="currentRow.unit"></el-input></div>
              </el-col>
              <el-col :span="6">
                <el-popover
                  v-model="cusValue"
                  placement="bottom"
                  width="100%"
                  trigger="click">
                  <div class="price-popover">
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>人工费：</div>
                      <el-input v-model="currentRow.artificialCustomerPrice" type="number" @blur="onModifyQuota('artificialCustomerPrice', null, false, 1)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>辅材费：</div>
                      <el-input v-model="currentRow.auxiliaryCustomerPrice" type="number" @blur="onModifyQuota('auxiliaryCustomerPrice', null, false, 1)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>机械费：</div>
                      <el-input v-model="currentRow.mechanicsCustomerPrice" type="number" @blur="onModifyQuota('mechanicsCustomerPrice', null, false, 1)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item">
                      <div>其他费：</div>
                      <el-input v-model="currentRow.otherCustomerPrice" type="number" @blur="onModifyQuota('otherCustomerPrice', null, false, 1)" class="flex-1 no-style-input"></el-input>
                    </div>
                  </div>
                  <div slot="reference" class="info-item cursor">
                    <div class="flex align-center">
                      <div class="flex-1" :style="{color: currentRow.customerPrice ? '#30313a' : '#b6b6b6'}"><span style="color: #30313a">客户价：</span>{{currentRow.customerPrice || '请选择'}}</div>
                      <i class="el-icon-arrow-down" :class="{'active': cusValue}"></i>
                    </div>
                  </div>
                </el-popover>
              </el-col>
              <el-col :span="6" class="info-item">
                <el-popover
                  v-model="cosValue"
                  placement="bottom"
                  width="100%"
                  trigger="click">
                  <div class="price-popover">
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>人工费：</div>
                      <el-input v-model="currentRow.artificialCostPrice" type="number" @blur="onModifyQuota('artificialCostPrice', null, false, 2)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>辅材费：</div>
                      <el-input v-model="currentRow.auxiliaryCostPrice" type="number" @blur="onModifyQuota('auxiliaryCostPrice', null, false, 2)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item border-b-dashed-e2">
                      <div>机械费：</div>
                      <el-input v-model="currentRow.mechanicsCostPrice" type="number" @blur="onModifyQuota('mechanicsCostPrice', null, false, 2)" class="flex-1 no-style-input"></el-input>
                    </div>
                    <div class="price-popover-item">
                      <div>其他费：</div>
                      <el-input v-model="currentRow.otherCostPrice" type="number" @blur="onModifyQuota('otherCostPrice', null, false, 2)" class="flex-1 no-style-input"></el-input>
                    </div>
                  </div>
                  <div slot="reference" class="info-item cursor">
                    <div class="flex align-center">
                      <div class="flex-1" :style="{color: currentRow.customerPrice ? '#30313a' : '#b6b6b6'}"><span style="color: #30313a">成本价：</span>{{currentRow.costPrice || '请选择'}}</div>
                      <i class="el-icon-arrow-down" :class="{'active': cosValue}"></i>
                    </div>
                  </div>
                </el-popover>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>分包价：<el-input placeholder="请输入" type="number" class="flex-1 no-style-input" @blur="onModifyQuota('subcontractPrice')" v-model="currentRow.subcontractPrice"></el-input></div>
              </el-col>
            </el-row>
          </div>
          <div class="text-left font-12-30313a h-100" v-if="smallTabIndex === 1">
            <el-input type="textarea" v-if="currentRow.id" :rows="5" v-model="currentRow.workmanship" @blur="onModifyQuota('workmanship')"></el-input>
          </div>
          <div class="h-100 flex-column" v-if="smallTabIndex === 2">
            <div class="mb-10 flex">
              <div class="btn-24-bg-ff flex align-center mr-5" @click="onAddQuotaQuantity">
                <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
                添加定额
              </div>
              <div class="btn-24-bg-ff flex align-center mr-5" @click="collectPrice(0)">
                <div class="mr-5">
                  <i class="el-icon-s-ticket" style="color: #f5971d; font-size: 14px"></i>
                </div>
                客户价汇总
              </div>
              <div class="btn-24-bg-ff flex align-center mr-5" @click="collectPrice(1)">
                <div class="mr-5">
                  <i class="el-icon-s-ticket" style="color: #f5971d; font-size: 14px"></i>
                </div>
                成本价汇总
              </div>
              <div class="btn-24-bg-ff flex align-center mr-5" @click="onDeleteQuotaQuantity">
                <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
                删除
              </div>
            </div>
            <div class="flex-1">
              <erp-table class="grayTable" ref="erpTable2" :table-data="quotaQuantities" :is-edit="true"
                         @on-modify="onModifyQuantity" modify-method="on-modify" :column-data="quantityColumn"></erp-table>
            </div>
          </div>
          <div class="text-left flex h-100" v-if="smallTabIndex === 3">
            <div v-for="(item, index) in photoList" :key="index" class="mr-10 p-relative flex-column mb-10">
              <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList" fit="cover"></el-image>
              <div class="info-item" style="width: 90px">
                <el-input class="no-style-input font-12-30313a text-center" v-model="item.name" @blur="onModifyImg(item)" placeholder="请输入"></el-input>
              </div>
              <i class="el-icon-error delete-img" @click.stop="onRemoveImg(index)"></i>
            </div>
            <el-upload
              v-if="currentRow.id"
              class="small-upload"
              list-type="picture-card"
              multiple
              name="file"
              :httpRequest="httpRequestImg"
              :action="upload"
              :show-file-list="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" :title="mOrA + '定额分类'" width="357px" :visible.sync="isAddClassifyShow">
      <div style="padding: 10px 20px 20px">
        <div class="bg-ff font-12-ff5555 text-left align-center mb-8">
          <i class="el-icon-warning mr-5"></i>
          提示：标有 * 的为必填项！
        </div>
        <div class="flex align-center p-relative mb-10">
          <div class="require-tip">*</div>
          <div class="font-12-30313a mr-5">分类名称：</div>
          <el-input class="flex-1" v-model="classifyInfo.name" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center p-relative mb-10">
          <div class="font-12-30313a mr-5">分类编码：</div>
          <el-input class="flex-1" v-model="classifyInfo.code" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center p-relative mb-20">
          <div class="font-12-30313a mr-5">分类特项：</div>
          <el-input class="flex-1" v-model="classifyInfo.specialItem" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="resetClassify">重置</div>
        <div class="btn-30-bg-f5971d-s" @click="submitClassify">确定</div>
      </div>
    </el-dialog>
    <add-materialy ref="addMaterialy" @choose-material="onSubmitQuantity" title="添加定额用量"></add-materialy>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
import AddMaterialy from '../customer/enterRoomItem/AddMaterialy.vue'
export default {
  name: 'quotaDefine',
  components: {Pagination, MoveHorizon, CateMenu, ErpTable, MoveVertical, AddMaterialy},
  data () {
    return {
      upImport: `${this.$store.state.API_URL_9010}/budget/import`,
      keywords: '',
      page: 1,
      limit: 20,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      mOrA: '新增',
      isAddClassifyShow: false,
      classifyList: [],
      classifyInfo: {},
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        },
        {
          field: 'switch',
          title: '启用',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'status',
            methodName: 'on-switch',
            type: 'switch',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'isModified',
          title: '修改',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isModified',
            methodName: 'on-change-modify',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'specialItem',
          title: '特项',
          width: '60',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'code',
          title: '定额编码',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'name',
          title: '工作内容',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'unit',
          title: '单位',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'costPrice',
          title: '成本价',
          minWidth: '120',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'customerPrice',
          title: '客户价',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'subcontractPrice',
          title: '分包价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'grossProfitRate',
          title: '毛利率',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'artificialCustomerPrice',
          title: '人工客户价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'auxiliaryCustomerPrice',
          title: '辅料客户价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'mechanicsCustomerPrice',
          title: '机械客户价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'otherCustomerPrice',
          title: '其它客户价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'artificialCostPrice',
          title: '人工成本价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'auxiliaryCostPrice',
          title: '辅料成本价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'mechanicsCostPrice',
          title: '机械成本价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'otherCostPrice',
          title: '其它成本价',
          width: '150',
          editRender: {
            name: 'input'
          }
        }
      ],
      chooseMenuId: 0,
      currentClassify: {},
      loading: false,
      tableData: [],
      srcList: [],
      smallTab: ['项目内容', '工艺说明', '定额用量', '定额图片'],
      smallTabIndex: 0,
      isErcodeShow: false,
      currentRow: {},
      quotaQuantities: [],
      photoList: [],
      quantityColumn: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        },
        {
          field: 'type',
          title: '人材机',
          width: '120',
          formatter: 'toQuotaType',
          editType: 'select',
          editRender: {
            name: 'select',
            options: [
              {
                value: 1,
                label: '人工'
              },
              {
                value: 2,
                label: '辅料'
              },
              {
                value: 3,
                label: '机械'
              },
              {
                value: 4,
                label: '其他'
              }
            ]
          }
        }, {
          field: 'specialItem',
          title: '特项',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'name',
          title: '材料名称',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'unit',
          title: '单位',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'quantity',
          title: '数量',
          width: '80',
          editRender: {
            name: 'input'
          },
          editType: 'number'
        }, {
          field: 'customerPrice',
          title: '客户单价',
          width: '100',
          editRender: {
            name: 'input'
          },
          editType: 'number'
        }, {
          field: 'totalCustomer',
          title: '客户合价',
          width: '100'
        }
      ],
      cusValue: false,
      cosValue: false,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      isAddQuantityShow: false,
      isClassifyShow: true,
      permission: []
    }
  },
  created () {
    this.getPermission()
    this.getClassify()
  },
  mounted () {},
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'projectQuotaDefine',
        parentGroup: 'projectQuotaDefine'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    httpRequestImport (e) {
      let formData = new FormData()
      formData.append('file', e.file)
      formData.append('classifyId', this.currentClassify.id)
      this.axios.post(`${this.$store.state.API_URL_9010}/quota/import`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: onloadRes.data.msg,
            type: 'success'
          })
          this.getQuota()
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message.error('导入失败！')
      })
    },
    // 导出
    materialExport () {
      window.location.href = this.$store.state.API_URL_9010 + '/quota/exportExcelQuota?classifyId=' + this.currentClassify.id
    },
    collectPrice (type) {
      let priceArr = this.$refs.erpTable2.getSelectEvent()
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        nameArr.push(priceArr[i].name)
      }
      if (priceArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要汇总的用量'
        })
        return
      }
      let typeText = type === 0 ? 'CustomerPrice' : 'CostPrice'
      let artificialPrice = `artificial${typeText}`
      let auxiliaryPrice = `auxiliary${typeText}`
      let mechanicsPrice = `mechanics${typeText}`
      let otherPrice = `other${typeText}`
      let price = type === 0 ? 'customerPrice' : 'costPrice'
      let params = {
        id: this.currentRow.id,
        [price]: 0,
        [artificialPrice]: 0,
        [auxiliaryPrice]: 0,
        [mechanicsPrice]: 0,
        [otherPrice]: 0
      }
      for (let i = 0; i < priceArr.length; i++) {
        params[price] += priceArr[i][price]
        switch (priceArr[i].type) {
          case 1:
            params[artificialPrice] += priceArr[i][price] || 0
            break
          case 2:
            params[auxiliaryPrice] += priceArr[i][price] || 0
            break
          case 3:
            params[mechanicsPrice] += priceArr[i][price] || 0
            break
          case 4:
            params[otherPrice] += priceArr[i][price] || 0
            break
        }
      }
      this.currentRow = {
        ...this.currentRow,
        ...params
      }
      this.modifyQuotaByParam(params)
    },
    onDeleteQuotaQuantity () {
      let priceArr = this.$refs.erpTable2.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        idArr.push(priceArr[i].id)
        nameArr.push(priceArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('quotaQuantities/deleteByIds', that.qs.stringify({ids: idArr.join(',')})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.erpTable2.setAllSelection(false)
            that.getQuotaQuantities(true)
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onModifyQuantity (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('quotaQuantities/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getQuotaQuantities()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSubmitQuantity (data, option) {
      let params = {
        name: data.name,
        quotaId: this.currentRow.id,
        type: 1,
        specialItem: data.specialItem,
        code: data.code,
        model: data.model,
        unit: data.salesUnit,
        quantity: 1,
        customerPrice: data[option.customerPriceField],
        costPrice: data[option.costPriceField],
        materialId: data.id
      }
      this.axios.post('quotaQuantities/save', params).then(res => {
        if (res.data.success) {
          this.$message.success('添加用量成功')
          this.getQuotaQuantities()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAddQuotaQuantity () {
      this.$refs.addMaterialy.addMaterialyVisible = true
    },
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 3)
      formData.append('description', '')
      let that = this
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        let params = {
          path: onloadRes.data.data.path,
          quotaId: that.currentRow.id
        }
        this.axios.post('quotaPhoto/save', params).then(res => {
          if (res.data.success) {
            this.$message.success('上传成功！')
            this.getQuota()
            that.photoList.push({
              completePath: res.data.data.completePath,
              quotaId: that.currentRow.id,
              name: '',
              id: res.data.data.id
            })
            that.srcList.push(res.data.data.completePath)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    onModifyImg (img) {
      let params = {
        id: img.id,
        name: img.name
      }
      this.axios.post('quotaPhoto/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onRemoveImg (index) {
      let that = this
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let img = that.photoList[index]
        that.axios.post('quotaPhoto/deleteById', that.qs.stringify({id: img.id})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功！')
            that.getQuota()
            that.photoList.splice(index, 1)
            that.srcList.splice(index, 1)
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    getQuotaQuantities () {
      if (this.currentRow.id) {
        this.axios.post('quotaQuantities/list', {quotaId: this.currentRow.id}).then(res => {
          if (res.data.success) {
            this.quotaQuantities = res.data.data
          }
        })
        this.srcList = []
        this.axios.post('quotaPhoto/list', {quotaId: this.currentRow.id}).then(res => {
          if (res.data.success) {
            this.photoList = res.data.data
            for (let i = 0; i < this.photoList.length; i++) {
              this.srcList.push(this.photoList[i].completePath)
            }
          }
        })
      }
    },
    onModifyQuotaInRow (row, column, colName) {
      this.onModifyQuota(colName, row, true)
    },
    onChangeModify (row) {
      this.onModifyQuota('isModified', row, true)
    },
    onChangeStatus (row) {
      this.onModifyQuota('status', row)
    },
    onModifyQuota (key, row, notRefresh, type) {
      let params = null
      if (row) {
        params = {
          id: row.id,
          [key]: row[key]
        }
      } else {
        params = {
          id: this.currentRow.id,
          [key]: this.currentRow[key]
        }
      }
      if (type && type === 1) {
        params.customerPrice = parseFloat(this.currentRow.artificialCustomerPrice || 0) +
          parseFloat(this.currentRow.auxiliaryCustomerPrice || 0) + parseFloat(this.currentRow.mechanicsCustomerPrice || 0) +
          parseFloat(this.currentRow.otherCustomerPrice || 0)
        this.currentRow.customerPrice = params.customerPrice
      } else if (type && type === 2) {
        params.costPrice = parseFloat(this.currentRow.artificialCostPrice || 0) +
          parseFloat(this.currentRow.auxiliaryCostPrice || 0) + parseFloat(this.currentRow.mechanicsCostPrice || 0) +
          parseFloat(this.currentRow.otherCostPrice || 0)
        this.currentRow.costPrice = params.costPrice
      }
      this.axios.post('quota/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          if (!notRefresh) {
            this.getQuota(false)
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onDeleteQuota () {
      let priceArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        idArr.push(priceArr[i].id)
        nameArr.push(priceArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('quota/deleteByIds', that.qs.stringify({ids: idArr.join(',')})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.erpTable.setAllSelection(false)
            that.getQuota(true)
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    modifyQuotaByParam (params) {
      this.axios.post('quota/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.getQuota(false)
          this.$refs.erpTable.setAllSelection(false)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAddQuota () {
      let params = {
        priceFlag: this.currentClassify.priceFlag,
        inventoryFlag: this.currentClassify.inventoryFlag,
        classifyId: this.currentClassify.id,
        code: this.currentClassify.code,
        specialItem: this.currentClassify.specialItem
      }
      this.axios.post('quota/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'specialItem')
          this.total++
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    batchSetEnable (status) {
      let quotaArr = this.$refs.erpTable.getSelectEvent()
      if (!quotaArr.length) {
        // this.$message({
        //   message: `请先选择要设置的定额`,
        //   type: 'warning'
        // })
        let that = this
        this.$confirm(`是否批量${status === -1 ? '取消' : ''}启用？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            classifyId: this.currentClassify.id,
            status
          }
          that.modifyQuotaByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < quotaArr.length; i++) {
          idArr.push(quotaArr[i].id)
          nameArr.push(quotaArr[i].name)
        }
        this.$confirm(`是否将${nameArr.join('、')}批量${status === -1 ? '取消' : ''}启用？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            status
          }
          that.modifyQuotaByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    setDefaultCode () {
      let that = this
      this.$confirm(`是否批量修改默认编码？`, '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('quota/resetCode', {classifyId: that.currentClassify.id}).then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.getQuota(true)
          } else {
            this.$message({
              type: 'error',
              message: '已取消操作',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    setDefaultItem () {
      let quotaArr = this.$refs.erpTable.getSelectEvent()
      if (!quotaArr.length) {
        this.$message({
          message: `请先选择要设置的定额`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < quotaArr.length; i++) {
          idArr.push(quotaArr[i].id)
          nameArr.push(quotaArr[i].name)
        }
        this.$confirm(`是否将“${nameArr.join('、')}”批量修改为默认特项？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            specialItem: that.currentClassify.specialItem
          }
          that.modifyQuotaByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    submitClassify () {
      let type = null
      if (!this.classifyInfo.name) {
        this.$message.warning('请将分类名称补充完整')
      } else {
        let url = 'quotaClassify/save'
        type = 0
        if (this.mOrA === '修改') {
          url = 'quotaClassify/modify'
          type = 1
        }
        this.axios.post(url, this.classifyInfo).then(res => {
          if (res.data.success) {
            this.isAddClassifyShow = false
            this.$message.success(this.mOrA + '成功')
            this.Utils.updateList(this.classifyList, type, res.data.data)
            // this.getClassify(false)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    resetClassify () {
      this.classifyInfo = {
        ...this.classifyInfo,
        name: '',
        'specialItem': '',
        'code': '',
        'isModified': -1,
        status: -1
      }
    },
    onDeleteClassify (menu) {
      let that = this
      this.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('quotaClassify/deleteById', that.qs.stringify({id: menu.id})).then(res => {
          if (res.data.success) {
            // that.getClassify(that.chooseMenuId === menu.id)
            this.Utils.updateList(that.classifyList, 2, {id: res.data.data})
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onEditClassify (menu) {
      this.mOrA = '修改'
      this.isAddClassifyShow = true
      this.classifyInfo = menu
    },
    onAdd (menu) {
      this.mOrA = '添加'
      this.isAddClassifyShow = true
      this.classifyInfo = {
        companyId: this.$store.state.companyId,
        name: '',
        'specialItem': '',
        'code': '',
        'isModified': -1,
        status: -1
      }
      if (menu.id) {
        this.classifyInfo.path = menu.path + ',' + menu.id
        this.classifyInfo.parentId = menu.id
      }
    },
    onSearch (a) {
      this.page = 1
      this.isClassifyShow = false
      this.getClassify()
      this.getQuota(a)
    },
    jump (page) {
      this.page = page
      this.getQuota(1)
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.getQuota(true)
      }
    },
    getQuota (isRefresh) {
      this.tableData = []
      let params = {
        page: this.page,
        limit: this.limit,
        companyId: this.$store.state.companyId,
        keywords: this.keywords,
        searchAll: 1
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenuId
      }
      this.axios.post(`quota/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (isRefresh) {
            this.currentRow = {}
          }
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].status === 1) {
              this.tableData[i].unEditable = 'ALL'
            }
          }
          if (this.tableData.length > 0 && isRefresh) {
            this.currentRow = this.tableData[0]
          }
          this.getQuotaQuantities()
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`quotaClassify/findAllClassify`, {companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        // if (classify.children && classify.children.length) {
        //   this.getDefaultId(classify.children)
        // } else {
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getQuota(true)
        // }
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.getQuotaQuantities()
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    toBigImg () {
      this.isErcodeShow = true
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getQuota()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .delete-img {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 16px;
    color: #ff5555;
    cursor: pointer;
  }
  .price-popover {
    .price-popover-item {
      /*height: 20px;*/
      padding: 5px 10px 3px;
      line-height: 22px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #30313a;
    }
  }
  .el-icon-arrow-down {
    font-size: 14px;
    color: #30313a;
    transition: transform .3s;
    margin-bottom: 2px;
    font-weight: bold;
    &.active {
      transform: rotate(180deg);
    }
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  .el-icon-zoom-in {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #30313a;
  }
  .font-13-f5971d {
    font-size: 13px;
    color: #f5971d;
  }
  .el-card {
    height: 90px;
    border: 1px solid #e2e2e2;
    cursor: pointer;
  }
  .info-item > div{
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    color: #30313a;
    /*line-height: 20px;*/
    height: 20px;
    padding-bottom: 5px;
  }
  .require-tip {
    position: absolute;
    left: -10px;
    color: #ff5555;
    top: 10px;
  }
  .tabActive {
    position: relative;
    &:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      background-color: #f5971d;
      left: 0;
      bottom: 0;
    }
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/quotaDefine.vue